import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { convertCurrency, changeSelector } from '../../actions/buy'
import Symbol from './Symbol'

export class Balance extends Component {
  componentDidUpdate() {
    this.props.convertCurrency()
  }

  render() {
    return (
      <Div onClick={this.props.changeSelector}>
        <Left>
          <H4>Pay With:</H4>
          <H2>{this.props.fiat_amount}</H2>
        </Left>
        <Right>
          <Symbol />
        </Right>
      </Div>
    )
  }
}

const Div = styled.div`
  box-sizing: border-box;
  height: 93px;
  border: 1px solid #E6E7E8;
  display: flex;
  flex-direction: row;
`

const Left = styled.div`
  padding-left: 10px;
  flex-grow: 9;
`

const Right = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: center;
   align-items: center;
`

const H2 = styled.h2`
`

const H4 = styled.h4`
  height: 20px;
  width: 47px;
  color: #B3B3B3;
  font-family: Roboto;
  font-size: 11px;
  line-height: 20px;
`

const mapStateToProps = state => ({
  fiat_amount: state.buy.fiat_amount
})

const mapDispatchToProps = {
  convertCurrency,
  changeSelector
}

export default connect(mapStateToProps, mapDispatchToProps)(Balance)
